module.exports = __webpack_public_path__ + "static/media/linked-in.89b392f5.svg";